export interface Testimonial {
  id: string;
  name: string;
  business: string;
  businessType: 'Convenience Store' | 'Gas Station' | 'Liquor Store' | 'Grocery Store';
  location: string;
  testimonial: string;
  impact: string;
  photo: string;
  businessLogo?: string;
  metrics: {
    label: string;
    value: string;
  }[];
}

export interface SocialProofStat {
  totalStores: number;
  predictionsDelivered: number;
  satisfactionRate: string;
  paymentsTracked: string;
}

export interface TrustBadge {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 'maria-gonzalez',
    name: 'Maria Gonzalez',
    business: 'Corner Market Plus',
    businessType: 'Convenience Store',
    location: 'Houston, TX',
    testimonial: 'LotteryFlow transformed how I manage my lottery payments. I used to spend hours every week trying to figure out what I owed. Now it takes minutes, and I never miss a payment deadline.',
    impact: 'Reduced payment processing time by 85%',
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face',
    businessLogo: '/testimonials/logos/corner-market-plus.jpg',
    metrics: [
      { label: 'Time Saved', value: '12 hours/week' },
      { label: 'Payment Accuracy', value: '100%' },
      { label: 'Late Fees Avoided', value: '$2,400/year' }
    ]
  },
  {
    id: 'james-chen',
    name: 'James Chen',
    business: 'Pacific Gas & Go',
    businessType: 'Gas Station',
    location: 'Los Angeles, CA',
    testimonial: 'The automated payment forecasting is incredible. I can see exactly when my lottery payments are due and plan my cash flow accordingly. My accountant loves the detailed reports.',
    impact: 'Improved cash flow management by 60%',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
    businessLogo: '/testimonials/logos/pacific-gas-go.jpg',
    metrics: [
      { label: 'Cash Flow Accuracy', value: '98%' },
      { label: 'Accounting Time', value: '75% reduction' },
      { label: 'Payment Delays', value: '0 incidents' }
    ]
  },
  {
    id: 'sarah-williams',
    name: 'Sarah Williams',
    business: 'Williams Family Store',
    businessType: 'Convenience Store',
    location: 'Dallas, TX',
    testimonial: 'Before LotteryFlow, I was constantly worried about missing lottery commission payments. The automatic reminders and precise calculations give me complete peace of mind.',
    impact: 'Eliminated payment errors and late fees',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
    metrics: [
      { label: 'Error Reduction', value: '100%' },
      { label: 'Stress Level', value: 'Significantly Lower' },
      { label: 'Compliance Score', value: 'Perfect' }
    ]
  },
  {
    id: 'robert-patel',
    name: 'Robert Patel',
    business: 'Patel Brothers Mart',
    businessType: 'Convenience Store',
    location: 'Phoenix, AZ',
    testimonial: 'LotteryFlow pays for itself. The time I save on lottery payment calculations alone is worth more than the subscription cost. Plus, I never have to worry about compliance issues.',
    impact: 'ROI of 400% in the first year',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
    businessLogo: '/testimonials/logos/patel-brothers.jpg',
    metrics: [
      { label: 'ROI', value: '400%' },
      { label: 'Time Savings', value: '8 hours/week' },
      { label: 'Compliance Issues', value: '0 violations' }
    ]
  },
  {
    id: 'linda-thompson',
    name: 'Linda Thompson',
    business: 'Quick Stop Express',
    businessType: 'Gas Station',
    location: 'Miami, FL',
    testimonial: 'Managing multiple locations was a nightmare until I found LotteryFlow. Now I can track lottery payments for all my stores from one dashboard. Game changer!',
    impact: 'Streamlined operations across 3 locations',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=face',
    metrics: [
      { label: 'Locations Managed', value: '3 stores' },
      { label: 'Management Time', value: '60% reduction' },
      { label: 'Data Accuracy', value: '99.8%' }
    ]
  },
  {
    id: 'david-martinez',
    name: 'David Martinez',
    business: 'Martinez Liquor & More',
    businessType: 'Liquor Store',
    location: 'San Antonio, TX',
    testimonial: 'The customer support is outstanding. When I had questions during setup, they walked me through everything. The system works flawlessly and the predictions are spot-on.',
    impact: 'Achieved 99.9% payment prediction accuracy',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face',
    businessLogo: '/testimonials/logos/martinez-liquor.jpg',
    metrics: [
      { label: 'Prediction Accuracy', value: '99.9%' },
      { label: 'Setup Time', value: '30 minutes' },
      { label: 'Support Rating', value: '5 stars' }
    ]
  }
];

export const socialProofStats: SocialProofStat = {
  totalStores: 847,
  predictionsDelivered: 15420,
  satisfactionRate: '99.9%',
  paymentsTracked: '$2.8M+'
};

export const trustBadges: TrustBadge[] = [
  {
    id: 'security-certified',
    name: 'SOC 2 Certified',
    description: 'Enterprise-grade security standards',
    icon: '🔒'
  },
  {
    id: 'data-protection',
    name: 'GDPR Compliant',
    description: 'Full data protection compliance',
    icon: '🛡️'
  },
  {
    id: 'uptime-guarantee',
    name: '99.9% Uptime',
    description: 'Reliable service guarantee',
    icon: '⚡'
  },
  {
    id: 'support-rating',
    name: '5-Star Support',
    description: 'Exceptional customer service',
    icon: '⭐'
  }
];